import { render, staticRenderFns } from "./SeleccionEspecial.vue?vue&type=template&id=0c7e3fa4&"
import script from "./SeleccionEspecial.vue?vue&type=script&lang=js&"
export * from "./SeleccionEspecial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports